
import Vue from "vue";
import AppImageModal from "../../components/common/ImageModal.vue";
import { ChatMessage } from "../../models/chat/chat-message";
import { UserInfo } from "../../models/dossier/user-info";
import { AuthService } from "../../services/auth-service";
import { DossierService } from "../../services/dossier-service";

export default Vue.extend({
	data() {
		return {
			user: new UserInfo(),
			openImage: false
		};
	},
	props: {
		bubble: {
			type: Boolean,
			required: false,
		},
		value: {
			type: Object as () => ChatMessage,
			required: true
		},
		previous: {
			type: Object as () => ChatMessage,
			required: true,
			default: Object as () => ChatMessage
		},
		seperator: String
	},
	computed: {
		userID():number{
			if (!AuthService.wfUser){
				return 0;
			}
			return AuthService.wfUser.ID;
		},
		link(): string {
			return this.value.ThreadID ? "/chat/thread/" + this.value.ThreadID : "";
		},
		messageTime(): string {
			var date = new Date(this.value.TimeStamp);
			return date.getHours() + ":" + date.getMinutes();
		},
		locale(): string {
			return this.$i18n.locale;
		},
		isAttachementImage(): boolean {
			if (!this.value.FileType) {
				return false;
			}
			return this.value.FileType.indexOf("image") != -1;
		},
		cssImageUrl(): string {
			if (!this.value.FileURL) {
				return "";
			}
			return `url(${encodeURI(this.value.getFileUrl())})`;
		},
		icon(): string {
			if (!this.value.FileType) {
				return "";
			}
			if (this.value.FileType.indexOf("pdf") != -1) {
				return "file-pdf";
			}
			return "file-alt";
		},
	},
	methods: {
		closeImage() {
			this.openImage = false;
		}
	},
	mounted() {
	},
	created() {
		this.user = DossierService.getUser(this.value.UserID);
	},
	components: {
		AppImageModal
	},
	i18nEx: {
		componentPrefix: "components.chat-ChatMessage"
	}
});
